import { observer } from "mobx-react-lite";
import useSetPageTitle from "utilities/useSetPageTitle";
import "./LearningHub.scss";
import { LearningHubTabs } from "Routes";
import PageTabs from "components/PageTabs/PageTabs";
import i18next from "i18next";
import { useTranslation } from "react-i18next";

type TabRouteKeys = keyof typeof LearningHubTabs;

const tabNamesByRoutes: { [key in TabRouteKeys]: string } = {
  Modules: i18next.t("ModulesTabName", { ns: "learningHub" }),
  LearningHubCertifications: i18next.t("CertificationsTabName", { ns: "learningHub" })
}

export const LearningHub = observer(() => {
  const { t } = useTranslation();
  useSetPageTitle({ 
    title: t('LearningHub', { ns: 'learningHub' }), 
    subtitle: t('Description', { ns: 'learningHub' }) });

  return <PageTabs tabs ={tabNamesByRoutes} defaultTabName={tabNamesByRoutes.Modules} />;
});
